import { ClassTableFrame } from '@features/class/components/ClassTableFrame'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/classes/$classId/attendance')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Attendance'
        }
    }
})

function RouteComponent() {
    return (
        // <div className={'flex gap-3'}>
        //     <ClassTableFrame columnGroup='attendance' />
        //     <div>
        //         More attendance stuff to go here (attendance by periods, absent last lesson, etc)
        //     </div>
        // </div>
        <ClassTableFrame columnGroup='attendance' />
    )
}